module.exports = __webpack_public_path__ + "static/media/import-3d.d6a70690.png";